export const campaignStatusUpdateTranslations = {
    en: {
        status: "Status",
        statusRequired: "Status is required",
        comments: "Comments",
        commentsRequired: "Comments are required",

        pending: "Pending",
        approve: "Approve",
        reject: "Reject",
        complete: "Complete",

        submit: "Submit",
        updateSuccess: "Status Updated Successfully",
        updateError: "Failed to update status"
    },
    mr: {
        status: "स्थिती",
        statusRequired: "स्थिती आवश्यक आहे",
        comments: "टिप्पण्या",
        commentsRequired: "टिप्पण्या आवश्यक आहेत",

        pending: "प्रलंबित",
        approve: "मंजूर करा",
        reject: "नाकारा",
        complete: "पूर्ण करा",

        submit: "सबमिट करा",
        updateSuccess: "स्थिती यशस्वीरित्या अपडेट केली",
        updateError: "स्थिती अपडेट करण्यात अयशस्वी"
    }
};
